const  validatePassword = (password) => {
    if (password.length <= 5) {
        const message = `Минимальная длина пароля ${5} символов`;
        //const message = `${password.length}`;
        return message;
    } else {
       // const message = "ВСЕ ОК";
        return null;
    }
    


}

const  validateNickname = (password) => {
    if (password.length <= 6) {
        const message = `Минимальная длина пароля ${6} символов`;
        //const message = `${password.length}`;
        return message;
    } else {
       // const message = "ВСЕ ОК";
        return null;
    }
    


}

const  validateEmail= (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(email)) {
        const message = "Неправильный формат почты"; 
        return message;  
    }

    return null;
}

//VALIDATE IMAGE AVATAR TYPE FILES

const validateFileTypeAvatar = (inputElement) => {
    // var inputElement = document.getElementById('file-upload');
     var files = inputElement.files;
     console.log(files);
     if(files.length===0){
         //alert("Please choose a file first...");
         return false;
     }else{
         var filename = files[0].name;
  
         /* getting file extenstion eg- .jpg,.png, etc */
         var extension = filename.substr(filename.lastIndexOf("."));
  
         /* define allowed file types */
         var allowedExtensionsRegx = /(\.jpg|\.jpeg|\.png|\.gif|\.webp)$/i;
  
         /* testing extension with regular expression */
         var isAllowed = allowedExtensionsRegx.test(extension);
  
         if(isAllowed){
            // alert("File type is valid for the upload");
             /* file upload logic goes here... */
             return true;
         }else{
            // alert("Invalid File Type.");
             return false;
         }
     }
  }

  //VALIDATE IMAGE AVATAR SIZE FILES
 /* javascript function to validate file size */ 
 const validateFileSizeAvatar = (inputElement) => {
   // var inputElement = document.getElementById('file-upload');
    var files = inputElement.files;
    console.log(files);
    if(files.length===0){
       // alert("Please choose a file first...");
        return false;
    }
  
    var fileSize = files[0].size;
  
    /* 1024 = 1MB */
    var size = Math.round((fileSize / 1024));
  
    /* checking for less than or equals to 0.5MB file size */ 
    if (size <= 0.5*1024) {
        //console.log(size + 'size ok');
        return true;
        //alert("Valid file size");
        /* file uploading code goes here... */
    } else {
        //console.log('size bad');
       // alert( "Invalid file size, please select a file less than or equal to 2mb size");
       return false;
    }
}

//VALIDATE IMAGE NOTE TYPE FILES

const validateFileTypeNote = (inputElement) => {
    // var inputElement = document.getElementById('file-upload');
     var files = inputElement.files;
     console.log("10.1_Start validate type");
     console.log(files);
     if(files.length===0){
         //alert("Please choose a file first...");
         return false;
     }else{
         var filename = files[0].name;
  
         /* getting file extenstion eg- .jpg,.png, etc */
         var extension = filename.substr(filename.lastIndexOf("."));
  
         /* define allowed file types */
         var allowedExtensionsRegx = /(\.jpg|\.jpeg|\.png|\.gif|\.webp)$/i;
  
         /* testing extension with regular expression */
         var isAllowed = allowedExtensionsRegx.test(extension);
  
         if(isAllowed){
            // alert("File type is valid for the upload");
             /* file upload logic goes here... */
             console.log("10.1.1_TYPE GOOD validate ");
             return true;
         }else{
            // alert("Invalid File Type.");
            console.log("10.1.2_TYPE BAD validate ");
             return false;
         }
     }
  }

  //VALIDATE IMAGENOTE SIZE FILES
 /* javascript function to validate file size */ 
 const validateFileSizeNote= (inputElement) => {
   // var inputElement = document.getElementById('file-upload');
    var files = inputElement.files;
    console.log("10.3_Start validate size");
    console.log(files);
    if(files.length===0){
       // alert("Please choose a file first...");
        return false;
    }
  
    var fileSize = files[0].size;
  
    /* 1024 = 1MB */
    var size = Math.round((fileSize / 1024));
  
    /* checking for less than or equals to 0.5MB file size */ 
    if (size <= 0.5*1024) {
        //console.log(size + 'size ok');
        console.log("10.3.1_SIZE GOOD validate ");
        return true;
        //alert("Valid file size");
        /* file uploading code goes here... */
    } else {
       
        console.log("10.3.2_SIZE BAD validate");
       // alert( "Invalid file size, please select a file less than or equal to 2mb size");
       return false;
    }
}

//VALIDATE IMAGE NOTE TYPE FILES

const validateFileTypeNoteAfterCrop = (inputElement) => {
    // var inputElement = document.getElementById('file-upload');
     var file = inputElement;
     console.log("10.1_Start validate type after crop");
     console.log(file);
     if(!file){
         //alert("Please choose a file first...");
         return false;
     }else{
         var filename = file.name;
  console.log(file.name);
         /* getting file extenstion eg- .jpg,.png, etc */
         var extension = filename.substr(filename.lastIndexOf("."));
  
         /* define allowed file types */
         var allowedExtensionsRegx = /(\.jpg|\.jpeg|\.png|\.gif|\.webp)$/i;
  
         /* testing extension with regular expression */
         var isAllowed = allowedExtensionsRegx.test(extension);
  
         if(isAllowed){
            // alert("File type is valid for the upload");
             /* file upload logic goes here... */
             console.log("10.1.1_TYPE GOOD validate after crop");
             return true;
         }else{
            // alert("Invalid File Type.");
            console.log("10.1.2_TYPE BAD validate after crop");
             return false;
         }
     }
  }

  //VALIDATE IMAGENOTE SIZE FILES
 /* javascript function to validate file size */ 
 const validateFileSizeNoteAfterCrop= (inputElement) => {
   // var inputElement = document.getElementById('file-upload');
    var file = inputElement;
    console.log("10.3_Start validate size after crop");
    console.log(file);
    if(!file){
       // alert("Please choose a file first...");
        return false;
    }
  
    var fileSize = file.size;
  
    /* 1024 = 1MB */
    var size = Math.round((fileSize / 1024));
  
    /* checking for less than or equals to 0.5MB file size */ 
    if (size <= 0.5*1024) {
        //console.log(size + 'size ok');
        console.log("10.3.1_SIZE GOOD validate after crop");
        return true;
        //alert("Valid file size");
        /* file uploading code goes here... */
    } else {
       
        console.log("10.3.2_SIZE BAD validate after crop");
       // alert( "Invalid file size, please select a file less than or equal to 2mb size");
       return false;
    }
//VALIDATE  NOTE TYPE ADDFILES





}
const validateTypeAddFile = (inputElement) => {
    // var inputElement = document.getElementById('file-upload');
     var files = inputElement.files;
     console.log("10.1_Start validate type");
     console.log(files);
     if(files.length===0){
         //alert("Please choose a file first...");
         return false;
     }else{
         var filename = files[0].name;
  
         /* getting file extenstion eg- .jpg,.png, etc */
         var extension = filename.substr(filename.lastIndexOf("."));
  
         /* define allowed file types */
         var allowedExtensionsRegx = /(\.pdf|\.lir|\.spf|\.spr|\.opr)$/i;
  
         /* testing extension with regular expression */
         var isAllowed = allowedExtensionsRegx.test(extension);
  
         if(isAllowed){
            // alert("File type is valid for the upload");
             /* file upload logic goes here... */
             console.log("10.1.1_TYPE GOOD validate ");
             return true;
         }else{
            // alert("Invalid File Type.");
            console.log("10.1.2_TYPE BAD validate ");
             return false;
         }
     }
  }
//VALIDATE  SIZE ADDFILES
 /* javascript function to validate file size */ 
 const validateSizeAddFile= (inputElement) => {
   // var inputElement = document.getElementById('file-upload');
    var file = inputElement.files;
    console.log("10.3_Start validate size p");
    console.log(file);
    if(!file){
       // alert("Please choose a file first...");
        return false;
    } else {
  
    var fileSize = file[0].size;
  
    /* 1024 = 1MB */
    var size = Math.round((fileSize / 1024));
  console.log(size);
    /* checking for less than or equals to 10MB file size */ 
        if (size <= 10*1024) {
            //console.log(size + 'size ok');
            console.log("10.3.1_SIZE GOOD validate ");
            return true;
            //alert("Valid file size");
            /* file uploading code goes here... */
        } else {
        
            console.log("10.3.2_SIZE BAD validate ");
        // alert( "Invalid file size, please select a file less than or equal to 2mb size");
        return false;
        }
    }
}

export {validatePassword,validateEmail, validateFileTypeAvatar, validateFileSizeAvatar, 
    validateFileTypeNote, validateFileSizeNote, validateNickname, validateFileSizeNoteAfterCrop, 
    validateFileTypeNoteAfterCrop, validateTypeAddFile, validateSizeAddFile};